import { Trash2 } from "lucide-react";
import { api, getApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { toast } from "sonner";

export const DeleteCustomerCard = ({ customer, onDeleted }) => {
  const remove = async () => {
    try {
      await api.delete(`/admin/customers/${customer.id}`);
      toast.success("Customer deleted");
      onDeleted();
    } catch (err) {
      toast.error(getApiError(err));
    }
  };

  return (
    <div className="bg-white border border-red-200 rounded-lg p-6 max-w-2xl">
      <h3 className="font-display text-lg font-bold text-red-900">Delete customer</h3>
      <p className="text-sm text-slate-600 mt-2">
        Permanently removes this customer and their entire transaction history. This cannot be undone.
      </p>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button variant="outline" data-testid="delete-customer-btn" className="mt-4 border-red-300 text-red-700 hover:bg-red-50 gap-2">
            <Trash2 className="h-4 w-4" /> Delete customer
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent data-testid="delete-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Delete {customer.name}?</AlertDialogTitle>
            <AlertDialogDescription>
              This will permanently delete the customer and all transactions. The mobile number{" "}
              <span className="font-mono-num text-slate-900">{customer.mobile}</span> will become available again.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="delete-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid="delete-confirm" onClick={remove} className="bg-red-700 hover:bg-red-800">
              Yes, delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
